import React, { useEffect, useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import NumberFormat from "react-number-format";
import { checkDiscount } from "../../../../services/sales/discountService";
import { Badge } from "react-bootstrap";
import {
  calculateDiscount,
  amountByPercent,
  percentByAmount,
} from "../../../../utils/utils";
import { Table } from "react-bootstrap";
import _ from "lodash";
import { AttachMoney, Percent } from "@mui/icons-material";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import Illustration from "../../../../partials/content/Illustration";
import {
  FormArrayTextField,
  FormDateField,
  FormOutlinedNoMarginTextField,
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { getGlAccounts } from "../../../../services/setup/finance/financeSetupService";
import { getDiscount } from "../../../../services/sales/discountService";
import { Card } from "react-bootstrap";
import { DialogActions, InputAdornment, Typography } from "@material-ui/core";
import SalesItemDiscount from "./SalesItemDiscount";
import SalesItemPrice from "./SalesItemPrice";
import SalesItemUom from "./SalesItemUom";
import SalesTax from "./SalesTax";
import SalesProftiLoss from "./SalesProftiLoss";
import SalesSelectItem from "./SalesSelectItem";
import SalesAdditionalCost from "./SalesAdditionalCost";
import { DateTime } from "luxon";
function SalesItem({
  salesCardID = 0,
  journeyID = 0,
  property = "",
  propertyAddCost = "",
  onCloseDialog,
}) {
  const [openSearchItemPrice, setOpenSearchItemPrice] = useState(false);
  const [openSearchUom, setOpenSearchUom] = useState(false);
  const [itemSelected, setItemSelected] = useState(0);
  const [openProfitLoss, setOpenProfitLoss] = useState(false);
  const [openDiscount, setOpenDiscount] = useState(false);
  const [openSearchTax, setOpenSearchTax] = useState(false);
  const [taxLevel, setTaxLevel] = useState("");
  const [discounts, setDiscounts] = useState([]);
  const [cashAccountOptions, setCashAccountOptions] = useState([]);
  const [openSearchItem, setOpenSearchItem] = useState(false);
  const [openSearchItemType, setOpenSearchItemType] = useState(false);
  const [discount, setDiscount] = useState({
    ID: 0,
    discountName: "",
    discountType: 0,
    minPurchaseType: 0,
    discountAmountType: 1,
    discountPercent: 0,
    discountValue: 0,
    discountAmountOffItem: [],
  });
  const [tab, setTab] = useState({
    ID: 1,
    title: "Sellable Items",
    icon: "fas fa-boxes",
  });
  //const [openSalesItemDetail, setOpenSalesItemDetail] = useState(false);
  const [itemIndex, setItemIndex] = useState(0);
  const [buttonGroupActive, setButtonGroupActive] = useState(0);
  async function getGlAccountData() {
    const response = await getGlAccounts(1);
    const { data } = response.data;
    const cashAccountOptionsTmp = [];
    for (const account of data.glAccounts) {
      cashAccountOptionsTmp.push({
        label: account.accountName,
        value: account.ID,
      });
    }
    setCashAccountOptions(cashAccountOptionsTmp);
  }

  async function getDiscountData(discountID = 0) {
    if (discountID > 0) {
      const response = await getDiscount(discountID);
      const { data } = response.data;
      setDiscount(data.discount);
    }
  }
  const { setFieldValue, values, handleSubmit } = useFormikContext();

  useEffect(() => {
    getGlAccountData();
    getDiscountData(values.discountID);
  }, [values.discountID]);
  return (
    <React.Fragment>
      <FieldArray name={property}>
        {({ push, remove }) => (
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                {journeyID === 0 &&
                values[property] &&
                values[property].length > 0 ? (
                  <React.Fragment>
                    <button
                      type="button"
                      className="btn btn-label-info btn-md btn-pill btn-bold mr-2"
                      onClick={() => {
                        setOpenProfitLoss(true);
                      }}
                    >
                      <i className="fas fa-chart-line"></i>
                      Profit & loss
                    </button>
                    <button
                      type="button"
                      className="btn btn-label-info btn-md btn-pill btn-bold"
                      onClick={() => {
                        checkDiscountData();
                      }}
                    >
                      <i className="fas fa-percentage"></i>
                      Available Discounts
                    </button>
                  </React.Fragment>
                ) : null}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="card">
                  <Table borderless size="sm" responsive="xl">
                    {values[property] && values[property].length > 0 ? (
                      <thead className="text-center">
                        <tr>
                          <th style={{ width: "25%" }}>Item Name</th>
                          <th style={{ width: "5%" }}>Quantity</th>
                          {journeyID > 0 ? (
                            <th style={{ width: "5%" }}>Stock Quantity</th>
                          ) : null}
                          <th style={{ width: "10%" }}>Unit</th>
                          <th style={{ width: "20%" }}>Unit Price</th>
                          <th style={{ width: "15%" }}>Item Discount</th>
                          <th style={{ width: "20%" }}>Total Price</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    ) : null}
                    <tbody>
                      {values[property] && values[property].length > 0 ? (
                        values[property].map((item, index) => (
                          <tr key={index}>
                            <td>
                              <FormOutlinedNoMarginTextField
                                value={`${item.itemCode} ${item.itemName}`}
                                InputProps={{
                                  startAdornment:
                                    item.itemType > 0 ? (
                                      <InputAdornment position="start">
                                        <BootstrapTooltip
                                          title={item.itemTypeName}
                                        >
                                          <i
                                            className={
                                              item.itemType === 1
                                                ? "fas fa-boxes text-success"
                                                : item.itemType === 2
                                                ? "fas fa-tools text-primary"
                                                : item.itemType === 3
                                                ? "fas fa-building text-info"
                                                : item.itemType === 4
                                                ? "fas fa-boxes text-warning"
                                                : item.itemType === 5
                                                ? "fas fa-boxes text-danger"
                                                : item.itemType === 6
                                                ? "fab fa-dropbox text-dark"
                                                : null
                                            }
                                          ></i>
                                        </BootstrapTooltip>
                                      </InputAdornment>
                                    ) : null,
                                  readOnly: true,
                                }}
                              />
                            </td>
                            <td>
                              {journeyID > 0 ? (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="qty"
                                  quantityField
                                  margin="none"
                                  onBlur={(value) => {
                                    calculateItemTotalPrice(
                                      setFieldValue,
                                      item,
                                      index
                                    );
                                  }}
                                />
                              ) : !item.childItem &&
                                item.discountFreeItemID === 0 ? (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="qty"
                                  quantityField
                                  margin="none"
                                  onBlur={(value) => {
                                    calculateDiscount(
                                      item.discountPercent,
                                      values,
                                      property,
                                      "percent",
                                      index,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                    calculateItemTotalPrice(
                                      setFieldValue,
                                      item,
                                      index
                                    );
                                    changeQtyItemPackage(item);
                                  }}
                                  readonly={
                                    values.invoiceStatus > 1 &&
                                    values.giStatus > 1
                                      ? true
                                      : false
                                  }
                                />
                              ) : (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="qty"
                                  quantityField
                                  margin="none"
                                  readonly
                                />
                              )}
                            </td>
                            {journeyID > 0 ? (
                              <td>
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="stockQty"
                                  quantityField
                                  margin="none"
                                  readonly
                                />
                              </td>
                            ) : null}
                            <td>
                              {!item.childItem &&
                              item.itemPackageID === 0 &&
                              item.discountFreeItemID === 0 &&
                              journeyID === 0 ? (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  searchButton={
                                    values.invoiceStatus > 1 &&
                                    values.giStatus > 1
                                      ? false
                                      : true
                                  }
                                  readonly
                                  onSearchClick={() => {
                                    setItemIndex(index);
                                    setItemSelected(item);
                                    setOpenSearchUom(true);
                                  }}
                                />
                              ) : (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="uomName"
                                  margin="none"
                                  readonly
                                />
                              )}
                            </td>
                            <td>
                              {journeyID > 0 ||
                              (!item.childItem &&
                                item.discountFreeItemID === 0) ? (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="unitPrice"
                                  margin="none"
                                  currencyField
                                  currencyCode={values.currencyCode}
                                  searchButton={
                                    values.invoiceStatus > 1 &&
                                    values.giStatus > 1
                                      ? false
                                      : true
                                  }
                                  onSearchClick={() => {
                                    setItemIndex(index);
                                    setItemSelected(item);
                                    setOpenSearchItemPrice(true);
                                  }}
                                  onBlur={(value) => {
                                    calculateDiscount(
                                      item.discountPercent,
                                      values,
                                      property,
                                      "percent",
                                      index,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                    calculateItemTotalPrice(
                                      setFieldValue,
                                      item,
                                      index
                                    );
                                  }}
                                  readonly={
                                    journeyID > 0 ||
                                    (values.invoiceStatus > 1 &&
                                      values.giStatus > 1)
                                      ? true
                                      : false
                                  }
                                />
                              ) : (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="unitPrice"
                                  margin="none"
                                  currencyField
                                  currencyCode={values.currencyCode}
                                  readonly
                                />
                              )}
                            </td>
                            <td>
                              {item.discountAmountType === 1 ? (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="discountPercent"
                                  margin="none"
                                  percentButton
                                  onPercentClick={() => {
                                    setFieldValue(
                                      `${property}[${index}].discountAmountType`,
                                      2
                                    );
                                  }}
                                  onChangeValue={(value) => {
                                    calculateDiscount(
                                      value,
                                      values,
                                      property,
                                      "percent",
                                      index,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                    calculateItemTotalPrice(
                                      setFieldValue,
                                      values[property][index],
                                      index
                                    );
                                  }}
                                  readonly={
                                    item.discountFreeItemID > 0 ||
                                    item.discountAmountOffItemID > 0 ||
                                    !values[property][index].editable
                                      ? true
                                      : false
                                  }
                                />
                              ) : (
                                <FormArrayTextField
                                  arrayPropName={property}
                                  index={index}
                                  propName="discountAmount"
                                  margin="none"
                                  currencyField
                                  currencyCode={values.currencyCode}
                                  amountButton
                                  onAmountClick={() => {
                                    setFieldValue(
                                      `${property}[${index}].discountAmountType`,
                                      1
                                    );
                                  }}
                                  onChangeValue={(value) => {
                                    calculateDiscount(
                                      value,
                                      values,
                                      property,
                                      "amount",
                                      index,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                    calculateItemTotalPrice(
                                      setFieldValue,
                                      values[property][index],
                                      index
                                    );
                                  }}
                                  readonly={
                                    item.discountFreeItemID > 0 ||
                                    item.discountAmountOffItemID > 0 ||
                                    !values[property][index].editable
                                      ? true
                                      : false
                                  }
                                />
                              )}
                            </td>
                            <td>
                              <FormArrayTextField
                                arrayPropName={property}
                                index={index}
                                propName="totalPrice"
                                margin="none"
                                currencyField
                                currencyCode={values.currencyCode}
                                readonly
                              />
                            </td>
                            <td
                              style={{ whiteSpace: "nowrap" }}
                              className="text-center"
                            >
                              {item.discountFreeItemID > 0 ? (
                                <Badge
                                  className="my-2 float-right"
                                  variant="success"
                                >
                                  Free Item
                                </Badge>
                              ) : (
                                <React.Fragment>
                                  {!item.childItem &&
                                  values.invoiceStatus < 2 &&
                                  values.giStatus < 2 ? (
                                    <BootstrapTooltip
                                      title={
                                        item.deleteInd
                                          ? "Undo Delete"
                                          : "Delete Sales Item"
                                      }
                                    >
                                      <button
                                        type="button"
                                        className={`btn btn-icon btn-label-${
                                          item.deleteInd ? "warning" : "danger"
                                        } btn-md btn-circle mx-1`}
                                        onClick={() => {
                                          if (item.ID > 0 || item.childItem) {
                                            setFieldValue(
                                              `${property}[${index}].deleteInd`,
                                              !item.deleteInd
                                            );
                                          } else {
                                            setItemIndex(0);
                                            if (item.itemPackageID > 0) {
                                              removeItemPackages(index);
                                            } else {
                                              remove(index);
                                            }
                                          }
                                          calculateTotalPrice(
                                            index,
                                            -1,
                                            !item.deleteInd,
                                            false
                                          );
                                        }}
                                      >
                                        {item.deleteInd ? (
                                          <i className="fas fa-undo-alt"></i>
                                        ) : (
                                          <i className="fas fa-trash-alt"></i>
                                        )}
                                      </button>
                                    </BootstrapTooltip>
                                  ) : null}
                                </React.Fragment>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            className="text-center py-3"
                            colSpan={`${journeyID > 0 ? "8" : "7"}`}
                          >
                            <Illustration
                              imageSource="INVIFO Sales.png"
                              guidance="You don't have any Sales items yet"
                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                              size="sm"
                            ></Illustration>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td
                          className="text-center py-3"
                          colSpan={`${journeyID > 0 ? "8" : "7"}`}
                        >
                          {values.invoiceStatus < 3 ? (
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                if (
                                  values.customerID > 0 ||
                                  values.leadID > 0
                                ) {
                                  setOpenSearchItemType(true);
                                } else {
                                  Swal.mixin({
                                    customClass: {
                                      confirmButton:
                                        "btn btn-success btn-md btn-pill btn-bold",
                                    },
                                    buttonsStyling: false,
                                  }).fire({
                                    title: "Failed",
                                    text:
                                      "Please select Customer or Lead first",
                                    icon: "error",
                                    showCloseButton: true,
                                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                                  });
                                }
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Sales Item
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            {values[property] && values[property].length > 0 ? (
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <SalesAdditionalCost
                    property={propertyAddCost}
                    calculateTotalPrice={(
                      index = -1,
                      addCostIndex = -1,
                      addDeleteInd = false
                    ) => {
                      calculateTotalPrice(
                        index,
                        addCostIndex,
                        false,
                        addDeleteInd
                      );
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card>
                    <Card.Body className="pb-0">
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          {values.discountID > 0 ? (
                            <tr className="border-bottom">
                              <td style={{ width: "30%" }}>
                                <Typography className="mb-3 kt-font-bolder">
                                  Discount Applied
                                </Typography>
                              </td>
                              <td style={{ width: "60%" }} colSpan="2">
                                <Typography className="mb-3 kt-font-bolder">
                                  {values.discountName}
                                </Typography>
                              </td>
                              <td style={{ width: "10%" }}>
                                <BootstrapTooltip title="Delete Discount">
                                  <button
                                    type="button"
                                    className={`btn btn-icon btn-label-danger btn-md float-right btn-circle mx-1`}
                                    onClick={() => {
                                      deleteDiscount();
                                    }}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </BootstrapTooltip>
                              </td>
                            </tr>
                          ) : null}
                          <tr className="border-bottom">
                            <td style={{ width: "25%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Sub Total
                              </Typography>
                            </td>
                            <td style={{ width: "5%" }}></td>
                            <td style={{ width: "30%" }}></td>
                            <td style={{ width: "40%" }}>
                              <Typography
                                component="div"
                                className="mb-3 kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.subTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography className="my-3">Discount</Typography>
                            </td>
                            <td>
                              <div
                                className="btn-group btn-group-sm my-2 float-right"
                                role="group"
                              >
                                <BootstrapTooltip title="Input By Amount">
                                  <button
                                    type="button"
                                    className={`btn btn-${
                                      buttonGroupActive === 0
                                        ? "success"
                                        : "label-dark"
                                    } btn-sm btn-bold`}
                                    onClick={() => {
                                      setButtonGroupActive(0);
                                    }}
                                  >
                                    <AttachMoney />
                                  </button>
                                </BootstrapTooltip>
                                <BootstrapTooltip title="Input By Percentage">
                                  <button
                                    type="button"
                                    className={`btn btn-${
                                      buttonGroupActive === 1
                                        ? "success"
                                        : "label-dark"
                                    } btn-sm btn-bold`}
                                    onClick={() => {
                                      setButtonGroupActive(1);
                                    }}
                                  >
                                    <Percent />
                                  </button>
                                </BootstrapTooltip>
                              </div>
                            </td>
                            <td>
                              {buttonGroupActive === 0 ? (
                                <FormTextField
                                  label="Discount Amount"
                                  name="discountAmount"
                                  currencyField
                                  currencyCode={values.currencyCode}
                                  onChangeValue={(value) => {
                                    calculateDiscount(
                                      value,
                                      values,
                                      property,
                                      "amount",
                                      -1,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                  }}
                                  readonly={
                                    values.invoiceStatus > 1 ||
                                    values.giStatus > 1 ||
                                    discount.discountValue > 0 ||
                                    discount.discountPercent > 0
                                      ? true
                                      : false
                                  }
                                />
                              ) : buttonGroupActive === 1 ? (
                                <FormTextField
                                  label="Discount Percent"
                                  name="discountPercent"
                                  percentageField
                                  onBlur={(value) => {
                                    calculateDiscount(
                                      value,
                                      values,
                                      property,
                                      "percent",
                                      -1,
                                      setFieldValue,
                                      propertyAddCost
                                    );
                                  }}
                                  readonly={
                                    values.invoiceStatus > 1 ||
                                    values.giStatus > 1 ||
                                    discount.discountValue > 0 ||
                                    discount.discountPercent > 0
                                      ? true
                                      : false
                                  }
                                />
                              ) : null}
                            </td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.discountAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      - {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography className="my-3">Tax</Typography>
                            </td>
                            <td></td>
                            <td>
                              <FormTextField
                                label="Tax Percent"
                                name="taxPercent"
                                percentageField
                                searchButton={
                                  values.invoiceStatus > 1 ||
                                  values.giStatus > 1
                                    ? false
                                    : true
                                }
                                readonly
                                onSearchClick={() => {
                                  setTaxLevel("header");
                                  setOpenSearchTax(true);
                                }}
                              />
                            </td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.taxAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography className="my-3">
                                Additional Cost
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={values.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Grand Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={values.grandTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                  {journeyID > 0 ? (
                    <React.Fragment>
                      <Card className="mt-3">
                        <Card.Body>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormSelectField
                                label="Payment Method"
                                name="payMethod"
                                options={[
                                  { label: "Cash", value: 1 },
                                  { label: "Debit", value: 2 },
                                  { label: "Credit", value: 3 },
                                  { label: "Pay Later", value: 4 },
                                ]}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              {values.payMethod < 4 ? (
                                <FormSelectField
                                  label="Cash Account"
                                  name="cashAccountID"
                                  options={cashAccountOptions}
                                />
                              ) : (
                                <FormDateField
                                  label="Deadline Date"
                                  name="deadlineDate"
                                />
                              )}
                            </div>
                          </div>
                          {values.payMethod === 1 ? (
                            <div className="row">
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                <FormTextField
                                  label="Pay Amount"
                                  name="payAmount"
                                  currencyField
                                  onChangeValue={(value) => {
                                    if (value) {
                                      const changeAmount =
                                        parseFloat(value) - values.total;
                                      if (changeAmount) {
                                        setFieldValue("change", changeAmount);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          ) : null}
                          {values.payMethod === 2 || values.payMethod === 3 ? (
                            <div className="row">
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                <FormTextField label="Card No" name="cardNo" />
                              </div>
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                <FormTextField
                                  label="Card Name"
                                  name="cardName"
                                />
                              </div>
                            </div>
                          ) : null}
                        </Card.Body>
                        <Card.Footer>
                          <Table borderless size="sm" responsive="xl">
                            <tbody>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <Typography
                                    variant="h6"
                                    className="kt-font-bolder"
                                  >
                                    Payment Total
                                  </Typography>
                                </td>
                                <td style={{ width: "10%" }}></td>
                                <td style={{ width: "30%" }}></td>
                                <td style={{ width: "30%" }}>
                                  <Typography
                                    variant="h6"
                                    component="div"
                                    className="kt-font-bolder"
                                  >
                                    <NumberFormat
                                      value={values.payAmount}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      renderText={(value) => (
                                        <div className="float-right">
                                          {values.currencyCode} {value}
                                        </div>
                                      )}
                                    />
                                  </Typography>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Card.Footer>
                      </Card>
                    </React.Fragment>
                  ) : null}
                </div>
              </div>
            ) : null}
            <SalesSelectItem
              journeyID={journeyID}
              openSearchItemType={openSearchItemType}
              setOpenSearchItemType={setOpenSearchItemType}
              setOpenSearchItem={setOpenSearchItem}
              setTab={setTab}
              openSearchItem={openSearchItem}
              values={values}
              property={property}
              push={push}
              tab={tab}
              selectItem={selectItem}
            />
          </React.Fragment>
        )}
      </FieldArray>
      <SalesProftiLoss
        openProfitLoss={openProfitLoss}
        setOpenProfitLoss={setOpenProfitLoss}
        values={values}
        property={property}
      />
      <SalesTax
        openSearchTax={openSearchTax}
        setOpenSearchTax={setOpenSearchTax}
        propertyAddCost={propertyAddCost}
        taxLevel={taxLevel}
        values={values}
        property={property}
        itemIndex={itemIndex}
        setFieldValue={setFieldValue}
        calculateItemTotalPrice={calculateItemTotalPrice}
      />
      <SalesItemUom
        openSearchUom={openSearchUom}
        setOpenSearchUom={setOpenSearchUom}
        itemSelected={itemSelected}
        setFieldValue={setFieldValue}
        property={property}
        itemIndex={itemIndex}
      />
      <SalesItemDiscount
        discounts={discounts}
        property={property}
        openDiscount={openDiscount}
        setOpenDiscount={setOpenDiscount}
        onSelectDiscount={(selectedDiscount) => {
          setDiscount(selectedDiscount);
        }}
      />
      <SalesItemPrice
        openSearchItemPrice={openSearchItemPrice}
        setOpenSearchItemPrice={setOpenSearchItemPrice}
        itemSelected={itemSelected}
        customerID={values.customerID}
        leadID={values.leadID}
        exchangeRate={values.exchangeRate}
        setFieldValue={setFieldValue}
        property={property}
        itemIndex={itemIndex}
      />
      {salesCardID > 0 ? (
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              onCloseDialog();
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="submit"
            className="btn btn-label-success btn-md btn-pill btn-bold"
            onClick={handleSubmit}
          >
            <i className="fas fa-save"></i>
            Save
          </button>
        </DialogActions>
      ) : null}
    </React.Fragment>
  );

  function removeItemPackages(index) {
    let salesItem = [...values[property]];
    const itemPackageID = salesItem[index].itemPackageID;
    if (itemPackageID > 0) {
      salesItem = _.remove(salesItem, function(propertyItem) {
        return propertyItem.itemPackageID !== itemPackageID;
      });
    }
    setFieldValue(property, salesItem);
  }

  function calculateTotalPrice(
    currIndex = -1,
    addCurrIndex = -1,
    deleteInd = false,
    addDeleteInd = false
  ) {
    const salesItem = [...values[property]];
    const additionalCost = [...values[propertyAddCost]];
    let subTotal = 0;
    let grandTotal = 0;
    let dpAmount = 0;
    let addCostTotal = 0;
    const dpPercent = parseFloat(values.dpPercent);
    salesItem.forEach((item, indexQuote) => {
      if (!item.deleteInd && (!deleteInd || currIndex !== indexQuote)) {
        subTotal += parseFloat(item.totalPrice);
      } else if (!deleteInd && item.deleteInd && currIndex === indexQuote) {
        subTotal += parseFloat(item.totalPrice);
      }
    });

    additionalCost.forEach((item, index) => {
      if (!item.deleteInd && (!addDeleteInd || addCurrIndex !== index)) {
        addCostTotal += parseFloat(item.costPrice);
      } else if (!addDeleteInd && item.deleteInd && addCurrIndex === index) {
        addCostTotal += parseFloat(item.costPrice);
      }
    });

    let discountPercent = percentByAmount(values.discountAmount, subTotal);
    let discountAmount = values.discountAmount;
    if (discount.discountType === 1) {
      if (discount.discountAmountType === 2 && discount.discountValue > 0) {
        discountAmount = discount.discountValue;
        discountPercent = percentByAmount(discountAmount, subTotal);
        //setFieldValue("discountPercent", discountPercent);
      } else if (
        discount.discountAmountType === 1 &&
        discount.discountPercent > 0
      ) {
        discountPercent = discount.discountPercent;
        discountAmount = amountByPercent(discountPercent, subTotal);
        //setFieldValue("discountAmount", discountAmount);
      }
    }
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - discountAmount
    );
    grandTotal = subTotal - discountAmount + taxAmount;
    grandTotal += addCostTotal;
    if (dpPercent > 0) {
      dpAmount = amountByPercent(dpPercent, grandTotal);
      setFieldValue(`dpAmount`, dpAmount);
    }
    setFieldValue(`subTotal`, subTotal);
    setFieldValue("addCostTotal", addCostTotal);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue("discountAmount", discountAmount);
    setFieldValue("grandTotal", grandTotal);
  }

  function calculateItemTotalPrice(setFieldValue, item, index) {
    const salesItem = [...values[property]];
    const totalPrice = item.unitPrice * parseFloat(item.qty);
    const additionalCost = [...values[propertyAddCost]];
    salesItem[index].totalPrice =
      totalPrice - item.discountAmount + item.taxAmount;
    salesItem[index].minimumPrice = item.oriMinimumPrice * parseFloat(item.qty);
    let subTotal = 0;
    let grandTotal = 0;
    let dpAmount = 0;
    let addCostTotal = 0;
    const dpPercent = parseFloat(values.dpPercent);
    if (values) {
      salesItem.forEach((value) => {
        if (value.deleteInd === false) {
          if (value.totalPrice > 0) {
            subTotal += parseFloat(value.totalPrice);
          }
        }
      });
    }
    additionalCost.forEach((value) => {
      if (!value.deleteInd) {
        if (value.costPrice > 0) {
          addCostTotal += parseFloat(value.costPrice);
        }
      }
    });
    let discountPercent = percentByAmount(values.discountAmount, subTotal);
    let discountAmount = values.discountAmount;
    if (discount.discountType === 1) {
      if (discount.discountAmountType === 2 && discount.discountValue > 0) {
        discountAmount = discount.discountValue;
        discountPercent = percentByAmount(discountAmount, subTotal);
        //setFieldValue("discountPercent", discountPercent);
      } else if (
        discount.discountAmountType === 1 &&
        discount.discountPercent > 0
      ) {
        discountPercent = discount.discountPercent;
        discountAmount = amountByPercent(discountPercent, subTotal);
        //setFieldValue("discountAmount", discountAmount);
      }
    }
    const taxAmount = amountByPercent(
      values.taxPercent,
      subTotal - discountAmount
    );
    grandTotal = subTotal - discountAmount + taxAmount;
    grandTotal += addCostTotal;
    if (dpPercent > 0) {
      dpAmount = amountByPercent(dpPercent, grandTotal);
      setFieldValue(`dpAmount`, dpAmount);
    }
    setFieldValue(property, salesItem);
    setFieldValue("addCostTotal", addCostTotal);
    setFieldValue(`subTotal`, subTotal);
    setFieldValue(`taxAmount`, taxAmount);
    setFieldValue(`discountPercent`, discountPercent);
    setFieldValue("discountAmount", discountAmount);
    setFieldValue(`grandTotal`, grandTotal);
  }

  function selectItem(item, itemPackage, varCode, valueName) {
    let salesItem = [...values[property]];
    if (item !== null) {
      let uomName = item.itemUom.uomName;
      let uomID = item.uomID;
      let discountAmountOffItemID = 0;
      let discountPercent = 0;
      let discountAmount = 0;
      let publishPrice = 0;
      if (values.exchangeRate > 0) {
        publishPrice = (1 / values.exchangeRate) * item.publishPrice;
      } else {
        publishPrice = 0;
      }
      salesItem.push({
        childItem: false,
        itemType: item.itemType,
        giStatus: 1,
        reserveStatus: 1,
        itemID: item.ID,
        itemType: item.itemType,
        itemTypeName: item.itemTypeName,
        itemCode: item.itemCode,
        itemName: item.itemName + " " + valueName,
        varCode: varCode,
        itemPackageID: 0,
        itemPackageDetailID: 0,
        discountFreeItemID: 0,
        discountAmountOffItemID,
        qty: 0,
        oriQty: 0,
        currencyID: item.currencyID,
        oriMinimumPrice: item.minimumPrice,
        minimumPrice: item.minimumPrice,
        uomID,
        uomName,
        unitPrice: publishPrice,
        discountAmountType: 1,
        discountPercent,
        discountAmount,
        taxPercent: 0,
        taxAmount: 0,
        totalPrice: 0,
        editable: true,
        deleteInd: false,
      });
      setFieldValue(property, salesItem);
    } else if (itemPackage !== null) {
      let itemPackageFound = false;
      for (const propertyItem of salesItem) {
        if (propertyItem.itemPackageID === itemPackage.ID) {
          itemPackageFound = true;
          break;
        }
      }
      if (!itemPackageFound) {
        if (values.exchangeRate > 1) {
          itemPackage.price = itemPackage.price * values.exchangeRate;
        }
        salesItem.push({
          childItem: false,
          itemID: 0,
          itemType: 6,
          itemTypeName: "Product Package",
          itemCode: itemPackage.packageCode,
          itemName: itemPackage.packageName,
          varCode: "",
          itemPackageID: itemPackage.ID,
          itemPackageDetailID: 0,
          discountFreeItemID: 0,
          discountAmountOffItemID: 0,
          qty: 0,
          oriQty: 0,
          currencyID: itemPackage.currencyID,
          oriMinimumPrice: 0,
          minimumPrice: 0,
          uomID: 0,
          uomName: "",
          unitPrice: itemPackage.price,
          discountAmountType: 1,
          discountPercent: 0,
          discountAmount: 0,
          taxPercent: 0,
          taxAmount: 0,
          totalPrice: itemPackage.price,
          editable: false,
          deleteInd: false,
        });
        for (const packageDetail of itemPackage.itemPackageDetails) {
          salesItem.push({
            ID: 0,
            childItem: true,
            itemID: packageDetail.itemID,
            itemType: packageDetail.itemType,
            itemTypeName: packageDetail.itemTypeName,
            itemCode: packageDetail.itemCode,
            itemName: packageDetail.itemName,
            varCode: packageDetail.varCode,
            itemPackageID: itemPackage.ID,
            itemPackageDetailID: packageDetail.ID,
            discountFreeItemID: 0,
            discountAmountOffItemID: 0,
            qty: packageDetail.qty,
            oriQty: packageDetail.qty,
            currencyID: packageDetail.item.currencyID,
            minimumPrice: packageDetail.item.minimumPrice,
            oriMinimumPrice: packageDetail.item.minimumPrice,
            uomID: packageDetail.uomID,
            uomName: packageDetail.uomName,
            unitPrice: 0,
            discountAmountType: 1,
            discountPercent: 0,
            discountAmount: 0,
            taxPercent: 0,
            taxAmount: 0,
            totalPrice: 0,
            editable: false,
            deleteInd: false,
          });
        }
        setFieldValue(property, salesItem);
      } else {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        }).fire({
          title: "Failed",
          text: "Item Package Already Selected",
          icon: "error",
          showCloseButton: true,
          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
        });
      }
    }
    setOpenSearchItem(false);
  }

  function deleteDiscount() {
    if (values.discountID > 0 && discount.ID > 0) {
      const salesItem = [...values[property]];
      const salesItemUpdate = [];
      if (discount.discountType === 1) {
        if (discount.discountValue > 0 || discount.discountPercent > 0) {
          setFieldValue("discountPercent", 0);
          setFieldValue("discountAmount", 0);

          for (const item of salesItem) {
            if (item.discountAmountOffItemID > 0) {
              item.discountPercent = 0;
              item.discountAmount = 0;
              item.totalPrice = item.qty * item.unitPrice;
            }
            salesItemUpdate.push(item);
          }
        }
      } else {
        for (const item of salesItem) {
          if (item.discountFreeItemID === 0) {
            salesItemUpdate.push(item);
          }
        }
      }
      setFieldValue("discountID", 0);
      setFieldValue("discountName", "");
      setFieldValue(property, salesItemUpdate);
      if (discount.discountType === 1) {
        calculateTotalPrice();
      }
      setDiscount({
        ID: 0,
        discountName: "",
        discountType: 0,
        minPurchaseType: 0,
        discountAmountType: 1,
        discountPercent: 0,
        discountValue: 0,
      });
    }
  }

  async function checkDiscountData() {
    let documentType = "";
    let documentDate = DateTime.now().startOf("day");
    let salesItem = [];
    if (property === "quotationItem") {
      documentType = "QUOT";
      documentDate = values.quotationDate;
    } else if (property === "salesOrderItem") {
      documentType = "SO";
      documentDate = values.orderDate;
    } else if (property === "directSalesItem") {
      documentType = "DS";
      documentDate = DateTime.now().startOf("day");
    }

    for (const item of values[property]) {
      if (item.discountFreeItemID > 0) {
        continue;
      }
      salesItem.push({
        itemID: item.itemID,
        varCode: item.varCode,
        qty: item.qty,
        uomID: item.uomID,
      });
    }
    const response = await checkDiscount({
      documentType,
      documentDate,
      currencyID: values.currencyID,
      exchangeRate: values.exchangeRate,
      grandTotal: values.grandTotal,
      salesItem,
    });
    const { data } = response.data;
    if (data.discounts.length > 0) {
      setDiscounts(data.discounts);
      setOpenDiscount(true);
    } else {
      Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        },
        buttonsStyling: false,
      }).fire({
        title: "Not Available",
        text: "There are no available discounts yet",
        icon: "info",
        showCloseButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
      });
    }
  }

  function changeQtyItemPackage(item) {
    const salesItem = [...values[property]];
    salesItem.forEach((propertyItem, quoteIndex) => {
      if (
        propertyItem.itemPackageID === item.itemPackageID &&
        propertyItem.itemPackageDetailID > 0
      ) {
        propertyItem.qty = propertyItem.oriQty * item.qty;
      }
    });
    setFieldValue(property, salesItem);
  }
}

export default SalesItem;
